export default __webpack_public_path__ + "static/media/adv_3.143c048e.svg";